export { Panel } from '../../ui/page-layout/panel';
export {
	contentHeightWhenFixed,
	contentInsetBlockStart,
	sideNavLiveWidthVar,
} from '../../ui/page-layout/constants';
